import {ConfigProvider, StaticHostConfig} from '@aboutyou/config';
import {GrpcConfig} from '@aboutyou/data-fetcher';
import {FeatureFlagSetup} from '@aboutyou/feature-flags';
import {HeadContext, HeadElementsProvider} from '@aboutyou/head-elements';
import {I18nProvider, StaticI18nConfig} from '@aboutyou/i18n';
import {HydrationProvider} from '@aboutyou/lazy-imports';
import {RouterProvider, RouterProviderProps} from '@aboutyou/router';
import {StorageState} from '@aboutyou/storage';
import {ToastContainer} from '@aboutyou/ui-components';
import React from 'react';
import {
  CheckoutHashDetails,
  CheckoutHashDetailsProvider,
} from './backend-services/Checkout/app-checkout/CheckoutHashDetailsProvider';
import {GrpcClientHostConfigProviderAppCheckout} from './providers/GrpcClientHostConfigProvider';

interface FeaturesProviderProps {
  headContext: HeadContext;
  i18nConfig: StaticI18nConfig;
  hostConfig: StaticHostConfig;
  routerConfig: RouterProviderProps;
  storage: StorageState;
  grpcConfig: GrpcConfig;
  featureFlagSetup: FeatureFlagSetup;
  documentReferrer: string;
  checkoutHashDetails: CheckoutHashDetails | null;
}

export const FeaturesProviderAppCheckout: React.FC<
  React.PropsWithChildren<
    Omit<
      FeaturesProviderProps,
      'featureFlagSetup' | 'storage' | 'documentReferrer'
    >
  >
> = ({
  children,
  headContext,
  i18nConfig,
  hostConfig,
  routerConfig,
  grpcConfig,
  checkoutHashDetails,
}) => {
  return (
    <HydrationProvider>
      <RouterProvider {...routerConfig}>
        <ConfigProvider config={hostConfig}>
          <I18nProvider {...i18nConfig} loadTranslationsFromOriginHost>
            <GrpcClientHostConfigProviderAppCheckout config={grpcConfig}>
              <HeadElementsProvider headContext={headContext}>
                <CheckoutHashDetailsProvider
                  checkoutHashDetails={checkoutHashDetails}
                >
                  {children}
                  <ToastContainer />
                </CheckoutHashDetailsProvider>
              </HeadElementsProvider>
            </GrpcClientHostConfigProviderAppCheckout>
          </I18nProvider>
        </ConfigProvider>
      </RouterProvider>
    </HydrationProvider>
  );
};
